import Card from 'react-bootstrap/Card';
import AdminDecisionsTable from './AdminDecisionsTable';
import PlayerDecisionsTable from './PlayerDecisionsTable';
import Team from './Team';
import { useAuth } from "../AuthProvider";
import { useTranslation } from 'react-i18next';
import { ADMIN, GAME_MASTER, PLAYER } from '../Roles';

const Decisions = ({ game, reloadGame }) => {
    const { t } = useTranslation();
    const auth = useAuth();
    const isGameMaster = auth.roles.includes(ADMIN) || auth.roles.includes(GAME_MASTER);
    const isPlayer = auth.roles.includes(PLAYER);
    const status = game.status;
    const playerTeam = sessionStorage.getItem("team");
    const team = game.teams.find(t => t.name === playerTeam);

    return <Card className="mt-4">
      <Card.Header>{t('game.decisions')}</Card.Header>
      <Card.Body>
        {isGameMaster &&
            <AdminDecisionsTable
                teams={game.teams}
                decisionDefinitions={game.decisionDefinitions}
                decisionValues={game.decisionValues}
                rounds={game.rounds}
                round={game.round}
                id={game.id}
                status={status}
                results={game.calculatedValues}
                reloadGame={reloadGame}
            />
        }
        {isPlayer &&
            <>
            <Team team={team} showName />
            <PlayerDecisionsTable
                decisionDefinitions={game.decisionDefinitions}
                decisionValues={game.decisionValues}
                rounds={game.rounds}
                round={game.round}
                auth={auth}
                id={game.id}
                status={status}
                results={game.calculatedValues}
            />
            </>
        }
      </Card.Body>
    </Card>;
};

export default Decisions;
